<template>                
    <p class="control">
	<input :name="name" :id="name" v-if="type == 'text'" 
	    :value="value" 
	    v-validate="rules" 
	    :class="{'input': true, 'is-danger': errors.has(name) || hasError }"
	    type="text" 
	    :placeholder="placeholder"
	    @input="updateData" :disabled="disabled">
            
        <input :name="name" :id="name" v-if="type == 'password'"
	    v-model="model" 
	    v-validate="rules" 
	    :class="{'input': true, 'is-danger': errors.has(name) }" 
	    type="password" 
	    :placeholder="placeholder"
	    @input="updateData">
            
        <transition name="fade-fast">
            <span v-show="errors.has(errorName)" class="help is-danger">{{ errorMsg(errors.first(errorName)) }}</span>
        </transition>
    </p>
</template>

<script>
import {EventBus} from '../../services/EventBus.js'

export default {
    name: 'bulma-input',
    props: {
		name: { required: true },
		value: { required: true },
		type: { default: 'text'},
		rules: { required: true },
		disabled: { required: false, optional: false },
		placeholder: { required: true },
        hasError: { required: false, default: false},
        scope: {required: false, default: ''}
    },
    inject: ['$validator'],
    data () {
	return {
	    model: this.value,
            errorName: this.scope == '' ? this.name : this.scope + "." + this.name
	};    
    },
    methods: {
		updateData(e) {
			this.$emit('input', e.target.value);
		},
		getter() {
			return this.value
		},
		context() {
		  return this
		},
        errorMsg(msg) {
            return msg !== undefined  ? msg.replace(/(\_\w)/g, function(m){return " " + m[1];}) : msg;
        },
    },    
    mounted () {  
		const options = {
		  scope: this.$parent,
		  getter: this.value,
		  context: this,
		  prettyName: this.name
		}

		this.$validator.attach(this.name, this.rules, options);
    },
    destroyed() {
      this.$validator.detach(this.name)
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>



</style>



// WEBPACK FOOTER //
// src/components/util/BulmaInput.vue